import FadeInImage from "./FadeInImage";

export default FadeInImage;